import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    if (this.slideTargets.length < 2) return

    this.index = 0
    this.showCurrent()
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  next() {
    this.index = (this.index + 1) % this.slideTargets.length
    this.showCurrent()
  }

  showCurrent() {
    this.slideTargets.forEach((slide, index) => {
      slide.classList.toggle("hidden", index !== this.index)
    })
  }
}
